import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks'
import {
  selectSalespersonFilterOptions,
  selectSalespersonFilterSelection,
  setSalespersonFilterSelection,
} from '@user/store/map'
import {
  IUserPreferenceGeneralListItemType,
  saveGeneralPreferencesBatch,
} from '@user/store/userPreferences/userPreferencesGeneral'
import { serializeSelection } from './useSalespersonFilter.utils'

// Read/write the current salesperson-filter selection, auto-saving on every
// change (Rule 8 — this control has no separate "Apply" gate).
export function useSalespersonFilterSelection() {
  const dispatch = useAppDispatch()
  const selection = useSelector(selectSalespersonFilterSelection)
  const options = useSelector(selectSalespersonFilterOptions)

  const setSelection = useCallback(
    (newSelection: string[]) => {
      dispatch(setSalespersonFilterSelection(newSelection))
      dispatch(
        saveGeneralPreferencesBatch([
          // "Everyone selected" is persisted as an empty value so a later-added
          // salesperson isn't silently filtered out for every existing user.
          {
            type: IUserPreferenceGeneralListItemType.MapViewFilteredSalespersonIds,
            value: serializeSelection(newSelection, options),
          },
        ]),
      )
    },
    [dispatch, options],
  )

  return { selection, setSelection }
}
